/*=========================================================================================
  File Name: moduleResourceActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	addResource({commit}, resource) {
		const {
			additional_info,
			email,
			identification,
			name,
			username,
			lastname,
			status,
			img_url,
			alias,
			status_id,
			typology_id,
			role_id,
			group_id,
			activity_id,
			visit_point_id,
			company_id,
			tfa,
		} = resource;
		return new Promise((resolve, reject) => {
			Api.post("/resource", {
				additional_info,
				email,
				identification,
				name,
				username,
				lastname,
				img_url,
				status_id,
				typology_id,
				role_id,
				group_id,
				activity_id,
				visit_point_id,
				company_id, // company id se envia cuando se crea primer recurso admin de empresa
				tfa: tfa ? 1 : 0,
			})
				.then((response) => {
					commit("ADD_RESOURCE", {...resource, id: response.data.id, alias, status});
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDataListResource({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/resource")
				.then((res) => {
					commit("SET_RESOURCES", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}, //
	fetchResourceFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || false,
				quantity: data.quantity || false,
				id: data.ids && data.ids.length > 0 ? data.ids.map(Number) : [],
				role_id: data.role_id || [],
				status_id: [],
				typology_id: [],
				category_id: [],
				name: data.name || "",
				lastname: data.lastname || "",
				username: data.username || "",
				identification: data.identification || "",
				email: data.email || "",
				imei: data.imei || "",
				additional_info: data.additional_info || [],
				order_by: data.order_by || "name",
				sort: data.sort || "DESC",
				company_id: data.company_id || null,
			};
			if (!data.page) delete data.page;
			if (!data.quantity) delete data.quantity;

			Api.post("/resource/filter", payload)
				.then((res) => {
					commit("SET_RESOURCES", res.data.records);
					if (data.assig) {
						commit("SET_RESOURCES_ACTIVITY", res.data.records);
					}
					commit("UPDATE_PAGINATION", res.data.pagination);
					commit("UPDATE_CURRENT_PAGE", {page: payload.page, quantity: payload.quantity});
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	fetchResourceFilterById({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 10,
				id: data.ids && data.ids.length > 0 ? data.ids.map(Number) : [],
				status_id: [],
				typology_id: [],
				category_id: [],
				name: data.name || "",
				lastname: data.lastname || "",
				username: data.username || "",
				identification: data.identification || "",
				email: data.email || "",
				imei: data.imei || "",
				additional_info: data.additional_info || [],
				order_by: data.order_by || "name",
				sort: data.sort || "DESC",
				fields: data.fields || null,
			};
			Api.post("/resource/filter", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	/**
	 *
	 * @param {*} param0
	 * @param {*} data
	 * data.fields received the next values into a array
	 * ["id","name","lastname","username","identification","email","uid","img_url",
	 * "imei","positionrecord_id","additional_info","code_recover_date","code_recover_pass",
	 * "company_id","company_name","role_id","role_name","status_id","status","typology_id",
	 * "typology_name","category_id","category_name","category_json_base","category_json_properties",
	 * "added_on","update_on" ]
	 */
	getResourcesByFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000,
				fields: data.fields || [],
				id: data.ids && data.ids.length > 0 ? data.ids.map(Number) : [],
				status_id: [],
				typology_id: [],
				category_id: [],
				name: data.name || "",
				lastname: data.lastname || "",
				username: data.username || "",
				identification: data.identification || "",
				email: data.email || "",
				imei: data.imei || "",
				additional_info: data.additional_info || [],
				order_by: data.order_by || "name",
			};
			Api.post("/resource/filter", payload)
				.then((res) => {
					commit("SET_RESOURCES_ACTIVITY", res.data.records);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getAvailableResources({commit}, payload = {event_id: 0, distance: 1}) {
		return new Promise((resolve, reject) => {
			Api.post("/on_demand/available_resources", payload)
				.then((res) => {
					commit("SET_AVAILABLE_RESOURCES", res.data.availability_resources);
					commit("SAVE_AVAILABLE_RESOURCES_PAYLOAD", payload);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	fetchResourceById({commit}, resourceId) {
		return new Promise((resolve, reject) => {
			Api.get(`/resource/${resourceId}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateResource({commit}, resource) {
		const {
			additional_info,
			email,
			identification,
			name,
			username,
			lastname,
			status,
			img_url,
			status_id,
			role_id,
			group_id,
			activity_id,
			visit_point_id,
			id,
			tfa,
		} = resource;
		return new Promise((resolve, reject) => {
			Api.put(`/resource/${id}`, {
				additional_info,
				email,
				identification,
				name,
				username,
				lastname,
				status,
				img_url,
				status_id,
				role_id,
				group_id,
				activity_id,
				visit_point_id,
				id,
				tfa: tfa ? 1 : 0,
			})
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeResource({commit}, resourceId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/resource/${resourceId}`)
				.then((response) => {
					commit("REMOVE_RESOURCE", resourceId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeImei({commit}, resource_id) {
		const payload = {
			resource_id,
		};
		return new Promise((resolve, reject) => {
			Api.post(`/resource/imei`, payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	validateExistEmail({commit}, email) {
		const payload = {
			email,
		};
		return new Promise((resolve, reject) => {
			Api.post(`/resource/email`, payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// ACTIONS FOR RESORCES
	fetchTypology({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/typology")
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	// /role/status/category/typology
	fetchDataSelect({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/role/status/category/typology", payload)
				.then((res) => {
					//commit('', res.data)
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	// Descargar archivo exportar from Storage cloud - Backend
	downloadResources({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/download/resource", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	addResourceActivity({commit}, resourceItem) {
		commit("ADD_RESOURCE_ACTIVITY", resourceItem);
	},
	removeResourceActivity({commit}, resourceItem) {
		commit("REMOVE_RESOURCE_ACTIVITY", resourceItem);
	},
	cleanResourceActivity({commit}) {
		commit("CLEAN_RESOURCE_ACTIVITY");
	},
	fetchResourceFilterByUsernane({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				fields: ["id", "name", "lastname", "username", "identification", "email", "img_url", "uid"],
				id: data.ids && data.ids.length > 0 ? data.ids.map(Number) : [],
				username: data.username || "",
				order_by: data.order_by || "name",
				sort: data.sort || "DESC",
			};
			Api.post("/resource/filter", payload)
				.then((res) => {
					commit("SET_RESOURCES_COMUNICATION", res.data.records);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
